import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormGroup, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DropdownBasic } from '../../../ensemble-config/models/dropdown-basic.model';
import { CommonModule } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'xpo-prime-multiselect',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MultiSelectModule],
  templateUrl: './xpo-prime-multiselect.component.html',
  styleUrls: ['./xpo-prime-multiselect.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => XpoPrimeMultiSelectComponent),
      multi: true,
    },
  ],
})
export class XpoPrimeMultiSelectComponent implements ControlValueAccessor {
  @Input() formGroup: FormGroup;
  @Input() formControlName = '';
  @Input() options: DropdownBasic[] = [];
  @Input() selectedObjectsToDisplay: DropdownBasic[] = [];
  @Input() name: string = '';
  @Input() placeholder: string = 'Select an item';
  @Input() required: boolean = false;
  @Input() optionLabel: string = 'label';

  isDisabled: boolean = false;

  private onChangeFn: (_: any) => void = () => {};
  private onTouchedFn: () => void = () => {};

  constructor() {}

  writeValue(value: any): void {}

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onSelect(event: any): void {
    this.selectedObjectsToDisplay = event.value?.sort((a, b) => a.label.localeCompare(b.label));
    this.formGroup.get(this.formControlName).patchValue(this.getValues());
  }

  private getValues(): string {
    return this.selectedObjectsToDisplay.map((item) => item.value).join(', ');
  }
}
